import { app } from '../../../../app';
import { Controller } from './upgrade-license.controller';

app.component('upgradeLicense', {
    bindings:{
        licenseDetails: '<',
        licenseTiers: '<',
    },
    controller: Controller,
    templateUrl: require('./upgrade-license.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/upgrade/upgrade-license.component.js